import { render, staticRenderFns } from "./checkList.vue?vue&type=template&id=19e5b920&"
import script from "./checkList.vue?vue&type=script&lang=js&"
export * from "./checkList.vue?vue&type=script&lang=js&"
import style0 from "./checkList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports